// Generated by CoffeeScript 1.12.7
(function() {
  $(document).ready(function() {
    var $optgroup, $option, $pc_last_menu, $pc_link_menu, $pc_model_menu, $pc_second_menu, $pc_top_menu, $sp_last_manu, $sp_modal_menu, $sp_second_menu, $sp_top_menu, $sp_top_menu_container, append_flg, base_h1_code, base_index_no, base_model_code, design_code, get_all_products_graphql, get_default_model, get_products_graphql, group_url, i, index, initialize_model_select, j, k, l, len, len1, len2, len3, link_tag, m, material_code, material_links, model_code, model_group, model_links, my$, now_url, prepend_option, product_json, redirect_url, ref, ref1, ref2, ref3, regex, selected_android, selected_model_code, selected_option, split_path, tags,
        $pc_second_menu_iphone_wrapper, $pc_second_menu_android_wrapper, $pc_second_menu_iphone_heading, $pc_second_menu_android_heading, $sp_model_menu,
        $sp_second_menu_iphone_wrapper, $sp_second_menu_android_wrapper, $sp_second_menu_iphone_heading, $sp_second_menu_android_heading, $sp_second_menu_iphone, $sp_second_menu_android;
    var isSmartPhone = navigator.userAgent.match(/iPhone|Android.+Mobile/);
    const ua = navigator.userAgent;
    // TOPページのポップアップ
    $('.popup-close').on('click', function() {
      $('.popUp-wrapper').addClass('d-none');
    });
    //カート追加時にポップアップ表示
    // $('.js-add-cart-trigger').on('click', function() {
    //   $('.js-ly-product-add').removeClass('d-none');
    //   if ($("input[name=buytogether]").is(':checked')) {
    //     $('.js-ly-product-add .is-buytogether').fadeIn();
    //   } else {
    //     $('.js-ly-product-add .is-buytogether').removeClass('d-none');
    //   }
    // });
    //SP時ヘッダーメニューバークリック時にバツ画像表示
    $('.navigation-toggle').on('click', function() {
      $('.open-menu-trigger').toggleClass('d-none');
      $('.openafter-menu-trigger').toggleClass('d-none');
    })
    //コラボレーションページの挙動
    //SP時は表示する画像を変更
    if (window.matchMedia('(max-width: 600px)').matches) {
      $('.img-character').addClass('d-none');
      $('.img-character-sp').removeClass('d-none');
    }

    get_default_model = function() {
      if (localStorage.getItem('collection.selectedmodel')) {
        return localStorage.getItem('collection.selectedmodel');
      } else {
        return window.fox.settings.default_model;
      }
    };
    now_url = location.href;
    regex = new RegExp(/mo_any/);
    if (regex.test(now_url)) {
      redirect_url = now_url.replace(/mo_any/, 'mo_' + get_default_model());
      location.href = redirect_url;
    }

    /*  グローバルメニューの処理 */
    // $pc_model_menu = $('.main-header .main-navigation-wrapper .navigation-list>.navigation-list-item:first>.navigation-dropdown-simple');
    // $pc_model_menu.find('.navigation-dropdown-item:first').remove();
    // $sp_model_menu = $('.main-header .main-navigation-wrapper.navigation-mobile>nav>.navigation-list>.navigation-list-item:first>.navigation-list.secondary');
    // $sp_model_menu.find('.navigation-list-item:first').remove();

    // $pc_second_menu_iphone_wrapper = $('<div data-navigation-item>').addClass('case-category-container is-iphone-container navigation-list-item has-dropdown');
    // $pc_second_menu_android_wrapper = $('<div data-navigation-item>').addClass('case-category-container is-android-container navigation-list-item has-dropdown');
    // $pc_second_menu_iphone_heading = $('<div>iPhone</div>').addClass('heading');
    // $pc_second_menu_android_heading = $('<div>Android</div>').addClass('heading');
    // $pc_model_menu.addClass('is-case');
    // $pc_model_menu.append($pc_second_menu_iphone_wrapper);
    // $pc_model_menu.append($pc_second_menu_android_wrapper);
    // $pc_model_menu.find('.is-iphone-container').append($pc_second_menu_iphone_heading);
    // $pc_model_menu.find('.is-android-container').append($pc_second_menu_android_heading);

    // $sp_second_menu_iphone_wrapper = $('<div data-navigation-item>').addClass('case-category-container is-iphone-container navigation-list-item has-dropdown');
    // $sp_second_menu_android_wrapper = $('<div data-navigation-item>').addClass('case-category-container is-android-container navigation-list-item has-dropdown');
    // $sp_second_menu_iphone_container = $('<div class="navigation-list-item-inner not-move">');
    // $sp_second_menu_android_container = $('<div class="navigation-list-item-inner not-move">');
    // $sp_second_menu_iphone_container.append($('<a href="/collections/series-iphone">iPhone</a>'));
    // $sp_second_menu_android_container.append($('<a href="/collections/series-android">Android</a>'));
    // $sp_second_menu_iphone_container.append($('<button class="navigation-dropdown-toggle" type="button" data-navigation-dropdown-toggle aria-expanded="false" aria-controls="navigation-list-secondary-' + index + '"><img src="https://cdn.shopify.com/s/files/1/0552/9262/4930/files/greater.png?v=1651807641" style="width: 12px;height: 16px;margin-top: 6px;"></button>'));
    // $sp_second_menu_android_container.append($('<button class="navigation-dropdown-toggle" type="button" data-navigation-dropdown-toggle aria-expanded="false" aria-controls="navigation-list-secondary-' + index + '"><img src="https://cdn.shopify.com/s/files/1/0552/9262/4930/files/greater.png?v=1651807641" style="width: 12px;height: 16px;margin-top: 6px;"></button>'));
    // $sp_model_menu.addClass('is-case');
    // $sp_second_menu_iphone = $('<ul class="navigation-list tertiary" id="navigation-list-tertiary-0">');
    // $sp_second_menu_android = $('<ul class="navigation-list tertiary" id="navigation-list-tertiary-1">');
    // $sp_second_menu_iphone_wrapper.append($sp_second_menu_iphone_container);
    // $sp_second_menu_android_wrapper.append($sp_second_menu_android_container);
    // $sp_second_menu_iphone_wrapper.append($sp_second_menu_iphone);
    // $sp_second_menu_android_wrapper.append($sp_second_menu_android);

    // $sp_model_menu.append($sp_second_menu_iphone_wrapper);
    // $sp_model_menu.append($sp_second_menu_android_wrapper);
    // index = 0;
    // ref = window.fox.settings.model_groups;
    // for (j = 0, len = ref.length; j < len; j++) {
    //   model_group = ref[j];

    //   group_url = '#';
    //   if (model_group.slug) {
    //     group_url = '/collections/' + model_group.slug;
    //   }

    //   index += 1;
    //   ref1 = model_group.code_sort;
    //   for (k = 0, len1 = ref1.length; k < len1; k++) {
    //     model_code = ref1[k];


    //     if (model_group.code.indexOf('AP') > -1) {
    //       $pc_last_menu = $('<div class="item">').append($('<a href="/collections/series-iphone/mo_' + model_code + '">').html(window.fox.settings.model[model_code]));
    //       $sp_last_menu = $('<li class="navigation-list-item">').append($('<a href="/collections/series-iphone/mo_' + model_code + '">' + window.fox.settings.model[model_code] + '</a>'));
    //       $pc_model_menu.find('.is-iphone-container').append($pc_last_menu);
    //       $sp_model_menu.find('.is-iphone-container .tertiary').append($sp_last_menu);
    //     } else {
    //       $pc_last_menu = $('<div class="item">').append($('<a href="/collections/series-android/mo_' + model_code + '">').html(window.fox.settings.model[model_code]));
    //       $sp_last_menu = $('<li class="navigation-list-item">').append($('<a href="/collections/series-android/mo_' + model_code + '">' + window.fox.settings.model[model_code] + '</a>'));
    //       $pc_model_menu.find('.is-android-container').append($pc_last_menu);
    //       $sp_model_menu.find('.is-android-container .tertiary').append($sp_last_menu);
    //     }
    //   }
    // }

    // $pc_iphone_menu_last = $('<div class="item">').append($('<a href="/collections/series-iphone">').html('全てのiPhoneケース'));
    // $pc_android_menu_last = $('<div class="item">').append($('<a href="/collections/series-android">').html('全てのAndroidケース'));
    // $pc_model_menu.find('.is-iphone-container').append($pc_iphone_menu_last);
    // $pc_model_menu.find('.is-android-container').append($pc_android_menu_last);

    // $('.small-form-actions > button.button').on('click', function() {
    //   return $('.product-options .form-actions>button').click();
    // });
    // if ($('.index-case-selections').length) {

    //   /* CASE SELECTIONS */
    //   $('.tab .button').on('click', function() {
    //     var click_type;
    //     click_type = $(this).data('type');
    //     $('.index-case-selections .container').removeClass('active');
    //     return $('.index-case-selections .container.' + click_type).addClass('active');
    //   });
    //   $('.case-selection-main .link-box').on('click', function() {
    //     var href;
    //     href = $(this).data('href') + '/';
    //     if (get_default_model()) {
    //       href += 'mo_' + get_default_model();
    //     }
    //     return location.href = href;
    //   });
    //   $('.index-case-selections .design-container a').each(function(index, element) {
    //     return $(element).attr('href', $(element).data('href') + '/mo_' + get_default_model());
    //   });
    // }

    /* =============================================
      チェックボックス
      ============================================= */
    if ($('.template-collection').length) {
      $('.collection-filters-tag-box').each(function(index, element) {
        if ($(element).data('filter-tag-box').slice(0, 3) === 'h1_') {
          return $(element).text(window.fox.settings.h1[$(element).data('filter-tag-box')]);
        }
      });

      /* コレクションページサイドバーの機種選択初期処理 */
      if ($('.manufacturer_selector').length) {
        selected_option = $('.collection-sidebar .model_selector .active').val();
        ref2 = window.fox.settings.model_groups_checkbox;

        /* --- 複数使用するものは関数に --- */
         //小カテゴリ「iphone」「android」リンクの配列
         var iPhone_model_code = [];
         var android_model_code = [];
        //小カテゴリ
        //「もっと」
        checkbox_increase = '<div class="checkbox-circle"> ＋ </div><p>もっと</p></div>'
        checkbox_increase_iphone = function(){ $('.manufacturer_selector .checkbox-open-btn').html(''+ checkbox_increase +'')};
        checkbox_increase_android = function(){ $('.manufacturer_selector_an .checkbox-open-btn').html(''+ checkbox_increase +'')};
        //「もっと少なく」
        checkbox_reduce = '<div class="checkbox-circle"> − </div><p>もっと少なく</p></div>'
        checkbox_reduce__iphone = function(){ $('.manufacturer_selector .checkbox-open-btn').html(''+ checkbox_reduce +'')};
        checkbox_reduce__android = function(){ $('.manufacturer_selector_an .checkbox-open-btn').html(''+ checkbox_reduce +'')};

        //大カテゴリのチェックボックス
        var Large_category =  function(){
          $manufacturer = '<label class="checkbox-selector manufacturer_'+ model_group.label +' manufacturer_link'+l+'"> <input type="checkbox" > '+ model_group.label + '</label>';
        }
        //OSと機種のコレクション
        var checkbox_collection = 'series-iphone ,series-android , xperia-series, galaxy-series, pixel-series, xiaomi-series, motorola-series';
        //iphone機種名リンク
        var iphonemodel_link = function(){
          if (model_code.match(/AP/)) {
            $option = '<label class="checkbox-selector iphone-checkbox model_link'+m+' checkboxmodel_link"> <input type="checkbox" >'+ window.fox.settings.model[model_code] + '</label>';
            $('.manufacturer_selector').append($option);
            //機種名を配列に格納
            iPhone_model_code.push(model_code);
            (function(m) {
              //機種名をチェックでリンクに飛ぶ
              console.log();
              $('.model_link'+m+'').change(function() {
              if (checkbox_collection.includes(handle)) {
                location.href = '/collections/all-case/mo_'+ iPhone_model_code[m] +'';
              } else {
                // handle/xxxx となっていたら + 'mo_' を追加
                // URLが/collections/文字列/文字列の形式かどうかをチェック
                var urlPath = window.location.pathname;
                var pathParts = urlPath.split('/').filter(function(part) { return part !== ''; });
                var isCollectionFormat = pathParts.length === 3 &&
                                        pathParts[0] === 'collections' &&
                                        pathParts[1] && pathParts[1].length > 0 &&
                                        pathParts[2] && pathParts[2].length > 0;
                console.log('URLパスの形式チェック:', urlPath, isCollectionFormat ? '指定形式(/collections/文字列/文字列)に一致' : '指定形式と異なる');

                if(isCollectionFormat){
                  if(urlPath.includes('mo_')){
                    location.href = urlPath.replace(/mo_[^+\/]+/, 'mo_' + iPhone_model_code[m]);
                  } else {
                    location.href = urlPath +'+mo_'+ iPhone_model_code[m] +'';
                  }
                } else {
                  location.href = '/collections/'+ handle +'/mo_'+ iPhone_model_code[m] +'';
                }
              }
              });
              if (current_tag.match('mo_'+ model_code  +'')){
              $('.model_link'+m+'').addClass("add_check");
              }
            })(m);
            //最後のループ後にもっと見るを配置
            if (m == len3 - 1){
              $('.manufacturer_selector').append('<div class="checkbox-open-btn iphone-checkbox checkboxmodel_link checkbox_increase_iphone">'+ checkbox_increase +'');
            }
          }
        }

        //android機種名リンク
        var androidmodel_link = function(){
          if (!model_code.match(/AP/)) {
            $option = '<label class="checkbox-selector android-checkbox androidmodel_link'+m+' checkboxmodel_link"> <input type="checkbox" >'+ window.fox.settings.model[model_code] + '</label>';
            $('.manufacturer_selector_an').append($option);
            android_model_code.push(model_code);
            (function(m) {
              console.log(handle);
              $('.androidmodel_link'+m+'').change(function() {
              if (checkbox_collection.includes(handle)) {
                location.href = '/collections/all-case/mo_'+ android_model_code[m] +'';
              } else {
                // location.href = '/collections/'+ handle +'/mo_'+ android_model_code[m] +'';
                var urlPath = window.location.pathname;
                var pathParts = urlPath.split('/').filter(function(part) { return part !== ''; });
                var isCollectionFormat = pathParts.length === 3 &&
                pathParts[0] === 'collections' &&
                pathParts[1] && pathParts[1].length > 0 &&
                pathParts[2] && pathParts[2].length > 0;
                console.log('URLパスの形式チェック:', urlPath, isCollectionFormat ? '指定形式(/collections/文字列/文字列)に一致' : '指定形式と異なる');

                if(isCollectionFormat){
                  if(urlPath.includes('mo_')){
                    location.href = urlPath.replace(/mo_[^+\/]+/, 'mo_' + android_model_code[m]);
                  } else {
                    location.href = urlPath +'+mo_'+ android_model_code[m] +'';
                  }
                } else {
                location.href = '/collections/'+ handle +'/mo_'+ android_model_code[m] +'';
                }
              }
              });
              if (current_tag.match('mo_'+ model_code  +'')){
                $('.androidmodel_link'+m+'').addClass("add_check");
                }
            })(m);
            if (m == len3 - 1){
              $('.manufacturer_selector_an').append('<div class="checkbox-open-btn android-checkbox checkboxmodel_link checkbox_increase_android">'+ checkbox_increase +'');
              }
          }
        }

        /* --- 大カテゴリ作成 --- */
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          model_group = ref2[l];
          Large_category();
          if(model_group.label == 'iPhone'){
            $('.manufacturer_selector').append($manufacturer);
          } else {
            $('.manufacturer_selector_an').append($manufacturer);
          }
         /* --- 小カテゴリ作成 --- */
          ref3 = model_group.code_sort;
          for (m = 0, len3 = ref3.length; m < len3; m++) {
            model_code = ref3[m];
              iphonemodel_link();
              androidmodel_link();
          }
        }

        /* --- 小カテゴリ機種名4つまで表示、5個目以降非表示 --- */
        //iphone(小カテゴリ機種名4つまで表示)
        var hideList_ip = '.iphone-checkbox:nth-of-type(n+6)';
        var num_ip = $('.iphone-checkbox').length;
        if (num_ip < 6) {
          $('.checkbox_increase_iphone').hide();
        };
        $(hideList_ip).hide();
        $('.checkbox_increase_iphone').click(function() {
          $(hideList_ip).toggle();
          if ($(hideList_ip).css('display') == 'none') {
            checkbox_increase_iphone();
          } else {
            checkbox_reduce__iphone();
          }
        });
        //Android(小カテゴリ機種名4つまで表示)
        var hideList_an = '.android-checkbox:nth-of-type(n+6)';
        var num_an = $('.android-checkbox').length;
        if (num_an < 6) {
          $('.checkbox_increase_android').hide();
        };
        $(hideList_an).hide();
        $('.checkbox_increase_android').click(function() {
          $(hideList_an).toggle();
          if ($(hideList_an).css('display') == 'none') {
            checkbox_increase_android();
          } else {
            checkbox_reduce__android();
          }
        });

        //商品ページで機種名は非表示
        $('.checkboxmodel_link').hide();

        //大カテゴリにチェック
        $('.manufacturer_iPhone').change(function() {
          $('.android-checkbox').hide();
          $('.iphone-checkbox').toggle();
          $(hideList_ip).hide();
          $(this).toggleClass("add_check_manufacturer");
          $('.manufacturer_Android').removeClass("add_check_manufacturer");
          checkbox_increase_iphone();
          if (num_ip < 6) {
            $('.checkbox_increase_iphone').hide();
          };
        });
        $('.manufacturer_Android').change(function() {
          $('.iphone-checkbox').hide();
          $('.android-checkbox').toggle();
          $(hideList_an).hide();
          $(this).toggleClass("add_check_manufacturer");
          $('.manufacturer_iPhone').removeClass("add_check_manufacturer");
          checkbox_increase_android();
          if (num_an < 6) {
            $('.checkbox_increase_android').hide();
          };
        });

        //機種名にチェックマーク付与されてる際の挙動
        if ($('.iphone-checkbox').hasClass('add_check')) {
          $('.iphone-checkbox').show();
          $('.manufacturer_iPhone').addClass("add_check_manufacturer");
        } else if ($('.android-checkbox').hasClass('add_check')) {
          $('.android-checkbox').show();
          $('.manufacturer_Android').addClass("add_check_manufacturer");
        };

        /* --- 小カテゴリの4つ目以上をチェックした際は小カテゴリは開いたまま表示させる --- */
        var className = $(".add_check").attr("class");
        if (className) {
        var checkbox_addcheck_num = className.replace(/[^0-9]/g, '');
        }

        if (checkbox_addcheck_num){
        if (checkbox_addcheck_num <= 3) {
          if (className.match(/iphone-checkbox/)) {
            $(hideList_ip).hide();
            checkbox_increase_iphone();
          } else {
            $(hideList_an).hide();
            checkbox_increase_android();
          }
        } else {
          if (className.match(/iphone-checkbox/)) {
            checkbox_reduce__iphone();
          } else {
            checkbox_reduce__android();
          }
        }
      }
        //大カテゴリにチェック時、4つ目以上をチェックした際の表示
        $('.manufacturer_iPhone').change(function() {
          if(className) {
            if (className.match(/iphone-checkbox/)) {
              if (checkbox_addcheck_num <= 3) {
                $(hideList_ip).hide();
                checkbox_increase_iphone();
              } else {
                if ($('.manufacturer_iPhone').hasClass('add_check_manufacturer')){
                $(hideList_ip).show();
                checkbox_reduce__iphone();
                }
              }
            }
          }
        });
        $('.manufacturer_Android').change(function() {
          if(className) {
            if (className.match(/android-checkbox/)) {
              if (checkbox_addcheck_num <= 3) {
                $(hideList_an).hide();
                checkbox_increase_android();
              } else {
                if ($('.manufacturer_Android').hasClass('add_check_manufacturer')){
                $(hideList_an).show();
                checkbox_reduce__android();
                }
              }
            }
          }
        });
        /* =============================================
          チェックボックここまで
        ============================================= */


        $('.collection-sidebar .model_selector option.readed').remove();
        if (selected_option) {
          $('.collection-sidebar .model_selector').val(selected_option);
        }
        $('.model_selector').on('change', function() {
          var $selected_option;
          $selected_option = $(this).find('option:selected');
          if ($selected_option.data('href')) {
            return location.replace($selected_option.data('href'));
          }
        });
        if (!$('.model_selector option.active').length) {
          selected_model_code = get_default_model();
          if (!selected_model_code) {
            selected_model_code = window.fox.settings.default_model;
          }
          if ($('.model_selector option.' + selected_model_code).length) {
            $('.model_selector').val(selected_model_code);
            if (location.href.lastIndexOf('/collections/mo_' + get_default_model()) === -1 && location.href.lastIndexOf('/collections/all') === -1 && location.href.indexOf('/mo_n000') === -1) {
              $('.model_selector').change();
            }
          } else {
            if ($('.model_selector option:selected').val()) {
              prepend_option = $('<option class="default" selected="selected">指定なし</option>');
              $('.model_selector').prepend(prepend_option);
              split_path = new URL(location.href).pathname.split('/');
              if (split_path.length === 3 && split_path[1] === 'collections' && split_path[2].indexOf('mo_') !== 0 && split_path[2].indexOf('series-') !== 0) {
                // location.replace('/' + split_path[1] + '/' + split_path[2] + '/mo_' + get_default_model());
              }
            } else {
              //$('.collection-sidebar-filter.model').addClass('d-none');
              $('.breadcrumbs-inner .all').addClass('d-none');
            }
          }
        } else {
          $('.collection-sidebar-filter.category .form-filter-wrapper a').each(function(index, element) {
            var h1tag;
            h1tag = $(element).data('filter-tag');
            if (h1tag === 'h1_008' || h1tag === 'h1_009' || h1tag === 'h1_010' || h1tag === 'h1_011' || h1tag === 'h1_012' || h1tag === 'h1_013') {
              return $(element).addClass('d-none');
            }
          });
          $('.collection-sidebar-filter.material .form-filter-wrapper a').each(function(index, element) {
            var h1tag;
            h1tag = $(element).data('filter-tag');
            if (h1tag.indexOf('m08') === 0 || h1tag.indexOf('m09') === 0 || h1tag.indexOf('m10') === 0 || h1tag.indexOf('m11') === 0 || h1tag.indexOf('m12') === 0 || h1tag.indexOf('m13') === 0) {
              return $(element).addClass('d-none');
            }
          });
        }
      }
      $('.collection-filters-tag-box').each(function(index, element) {
        if ($(element).data('filter-tag-box').slice(0, 3) === 'mo_') {
          return $(element).text(window.fox.settings.model[$(element).data('filter-tag-box').slice(3)]);
        }
      });
      $('.collection-filters-tag-box').each(function(index, element) {
        if ($(element).data('filter-tag-box').slice(0, 1) === 'm' && $(element).data('filter-tag-box').slice(0, 2) !== 'mo') {
          return $(element).text(window.fox.settings.material[$(element).data('filter-tag-box')]);
        }
      });
      $('.collection-filters-tag-box').each(function(index, element) {
        if ($(element).data('filter-tag-box').slice(0, 3) === 'cl_') {
          return $(element).text($(element).text().slice(3));
        }
      });
    }
    $('.header-search-form.form').on('submit', function() {
      $('#real-header-search').val("mo_n000 OR mo_" + get_default_model() + ' ' + $('#header-search').val().replace(/ /g, " "));
      return true;
    });
    if ($('.template-search').length) {
      $('.main-content>h1.page-header').html($('.main-content>h1.page-header').html().replace(/^"\w+\sOR\s\w+ /, '"'));
    }

    /* 機種判定 */
    selected_android = function() {
      var matched, matched2, matched3, ua1, ua2, ua3;
      matched = platform.ua.match(/^.*Android\s*[\d\.]*\s*;\s*(\w+.*)/);
      if (matched) {
        ua1 = matched[1].replace(/\s*ja-jp;\s*/, '').replace(/\s*en-us;\s*/, '').replace(/[\)\s;]+.*$/, '');
        matched3 = matched[1].match(/^(\w+\s+\w+\s+\w+)/);
        if (matched3) {
          ua3 = matched3[1];
          if (window.fox.settings.android_uas[ua3]) {
            return window.fox.settings.android_uas[ua3];
          }
        }
        matched2 = matched[1].match(/^(\w+\s+\w+)/);
        if (matched2) {
          ua2 = matched2[1];
          if (window.fox.settings.android_uas[ua2]) {
            return window.fox.settings.android_uas[ua2];
          }
        }
        return window.fox.settings.android_uas[ua1];
      }
      return void 0;
    };
    initialize_model_select = function() {
      var len4, len5, n, o, ref4, ref5;
      $('#init_mode_selector').append($('<option>選択してください</option>'));
      ref4 = window.fox.settings.model_groups;
      for (n = 0, len4 = ref4.length; n < len4; n++) {
        model_group = ref4[n];
        $optgroup = $('<optgroup>');
        $optgroup.attr('label', model_group.label);
        ref5 = model_group.code_sort;
        for (o = 0, len5 = ref5.length; o < len5; o++) {
          model_code = ref5[o];
          $option = $('<option>').data('model_code', model_code).text(window.fox.settings.model[model_code]);
          if (selected_option && selected_option === model_code) {
            $option.addClass('active');
          }
          $optgroup.append($option);
        }
        $('#init_mode_selector').append($optgroup);
      }
      $('#init_mode_selector').on('change', function() {
        localStorage.setItem('collection.selectedmodel', $(this).find('option:selected').data('model_code'));
        now_url = location.href;
        regex = new RegExp(/mo_\w{6}/);
        if (regex.test(now_url)) {
          redirect_url = now_url.replace(/mo_\w{6}/, 'mo_' + get_default_model());
          return location.href = redirect_url;
        } else {
          return location.href = '/collections/all-case/mo_' + get_default_model();
        }
      });
      if (localStorage.getItem('collection.selectedmodel') !== null) {
        $('.main-navigation .select_model .model_label,.footer-tapbar .select_model .model_label').html(window.fox.settings.model[get_default_model()]);
      } else {
        $('.main-navigation .select_model a, .footer-tapbar .select_model .model_label').html('スマホを選択する');
      }
      $('.main-navigation .select_model, .footer-tapbar .select_model').removeClass('d-none');
      $('.main-navigation .select_model a, .footer-tapbar .select_model .model_label').on('click', function() {
        if ($('.js-sp-select-container').hasClass('d-none')) {
          $('.js-sp-select-container').removeClass('d-none');
        } else {
          $('.js-sp-select-container').addClass('d-none');
        }
        return false;
      });
      $('.js-sp-select-container .sp-select .close_btn').on('click', function() {
        return $('.js-sp-select-container').addClass('d-none');
      });

      $('.js-toggle-sp-selector-trigger').on('click', function() {
        $('.js-sp-select-container').toggleClass('d-none');
      });

      return $('.js-sp-select-container .sp-select .form-actions .button').on('click', function() {
        localStorage.setItem('collection.selectedmodel', window.fox.settings.default_model);
        return location.href = '/collections/mo_' + window.fox.settings.default_model;
      });
    };
    initialize_model_select();
    if (localStorage.getItem('collection.selectedmodel') === null) {
      $('.js-sp-select-container').removeClass('d-none');
    } else {
      $('.js-sp-select-container .selected_model span').html(window.fox.settings.model[get_default_model()]);
      $('.js-sp-select-container .selected_model').removeClass('d-none');

      if (window.matchMedia('(min-width: 1024px)').matches) {
         var modelName = window.fox.settings.model[localStorage.getItem('collection.selectedmodel')]
         // note 機種の改廃を考慮し、modelNameの存在チェックをしておく
         if (modelName) {
           $('.js-selected-sp-container .selected-sp').html(modelName);
           $('.js-selected-sp-container').removeClass('d-none');
         } else {
           localStorage.removeItem('collection.selectedmodel');
         }
      }
    }
    if (platform.product === 'iPhone') {
      $.each(window.fox.settings.model_groups, function(index, val) {
        var i, link_tag, n;
        if (val['code'] === 'ip') {
          for (i = n = 0; n <= 3; i = ++n) {
            link_tag = $('<a>');
            link_tag.data('model_code', val['code_sort'][i]);
            link_tag.html(window.fox.settings.model[val['code_sort'][i]]);
            $('.auto-select').append($('<li>').append(link_tag));
          }
          return false;
        }
      });
    } else if (platform.os.family === 'Android' && platform.ua.indexOf('Android') !== -1) {
      model_code = selected_android();
      if (model_code !== void 0) {
        link_tag = $('<a>');
        link_tag.data('model_code', model_code);
        link_tag.html(window.fox.settings.model[model_code]);
        $('.auto-select').append($('<li>').append(link_tag));
      } else {
        i = 0;
        $.each(window.fox.settings.model_groups, function(index, val) {
          if (i > 3) {
            return false;
          }
          if (val['code'] !== 'ip') {
            link_tag = $('<a>');
            link_tag.data('model_code', val['code_sort'][0]);
            link_tag.html(window.fox.settings.model[val['code_sort'][0]]);
            $('.auto-select').append($('<li>').append(link_tag));
            return i++;
          }
        });
      }
    } else {
      $('.auto-select').append('端末が識別できませんでした');
    }

    // note スマホの場合は初期表示しない
    if (isSmartPhone) {
       $('.js-sp-select-container').addClass('d-none');
    }

      $('#js-toggle-footer-tapbar-content-trigger').on('click', function() {
        //$('.js-footer-search-form').toggleClass('active');
        $('.js-footer-search-form').toggle();
      });


    $('.js-selected-sp-container').on('click', function() {
      var $this = $(this);

      $this.addClass('d-none');
      $('.js-sp-select-container').removeClass('d-none');
    });

    return $('.auto-select a').on('click', function() {
      localStorage.setItem('collection.selectedmodel', $(this).data('model_code'));
      now_url = location.href;
      regex = new RegExp(/mo_\w{4}/);
      if (regex.test(now_url)) {
        redirect_url = now_url.replace(/mo_\w{4}/, 'mo_' + get_default_model());
        return location.href = redirect_url;
      } else {
        return location.href = '/collections/mo_' + get_default_model();
      }
    });
  });
  $(document).ready(function() {
  //ログアウト時ページが遷移
  var ref = new URL(document.referrer, "http://example.com/")
  $('.logout-button').on("click", function() {
    $.ajax( $(this).attr('href'))
    .done(function() {
      location.href = "/account/login";
    })
    return false;
  });
  if (ref.pathname) {
    if (ref.pathname == '/account') {
      $(".logout-text").text("ログアウトしました。");
    }
  }
  });
}).call(this);
